import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';
import { bankAccountsArraySchema } from 'back-office/shared/components/bank-accounts/bankAccountsValidation';
import { GestionnaireFormFieldNames } from './GestionnaireFormFieldNames';
import { GestionnaireFormValues } from './GestionnaireFormValues';

import { gerantValidationRules, optionalCompanyPhoneRule } from 'back-office/shared/components/gerant/gerantFields';
export const gestionnaireValidationRules: ValidationRules<keyof GestionnaireFormValues> = {
  ...gerantValidationRules,
  ...addressValidationRules,
  [GestionnaireFormFieldNames.CompanyName]: Yup.string()
    .required('La raison sociale est requise')
    .min(2, 'La raison sociale doit contenir au moins 2 caractères'),
  [GestionnaireFormFieldNames.Phone]: optionalCompanyPhoneRule,
  [GestionnaireFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Le numéro SIRET est requis')
    .matches(/^\d{14}$/, 'Le SIRET doit contenir 14 chiffres'),
  [GestionnaireFormFieldNames.Capital]: Yup.number()
    .required('Le capital est requis')
    .min(0, 'Le capital doit être positif'),
  [GestionnaireFormFieldNames.RcsCity]: Yup.string()
    .required('La ville RCS est requise'),
  [GestionnaireFormFieldNames.RcsNumber]: Yup.string()
    .required('Le numéro RCS est requis'),
  // ORIAS optionnel pour la nature Gestionnaire
  [GestionnaireFormFieldNames.OriasNumber]: Yup.string()
    .nullable()
    .notRequired(),
  [GestionnaireFormFieldNames.Rcp]: Yup.string()
    .nullable()
    .notRequired(),
  [GestionnaireFormFieldNames.BankAccounts]: bankAccountsArraySchema,
  [GestionnaireFormFieldNames.ComplaintEmail]: Yup.string()
    .nullable()
    .notRequired()
    .email('Format email invalide'),
  [GestionnaireFormFieldNames.FirstName]: Yup.string()
    .required('Le prénom est requis')
    .min(2, 'Le prénom doit contenir au moins 2 caractères'),
  [GestionnaireFormFieldNames.LastName]: Yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  [GestionnaireFormFieldNames.Email]: Yup.string()
    .required("L'email est requis")
    .email('Format email invalide'),
  [GestionnaireFormFieldNames.Username]: Yup.string()
    .required("Le nom d'utilisateur est requis")
    .min(3, "Le nom d'utilisateur doit contenir au moins 3 caractères"),
  [GestionnaireFormFieldNames.Password]: Yup.string()
    .required('Le mot de passe est requis')
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  [GestionnaireFormFieldNames.PlateformeIds]: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Au moins une plateforme est requise')
    .required('Les plateformes sont requises'),
};
